export const styles = (theme) => ({
  toolbarContainer: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  toolbarTitle: {
    fontSize: "1rem",
    color: "#263238",
    fontWeight: "500",
  },
  tableCell: {
    paddingTop: "16px",
    paddingBottom: "16px",
    color: "#263238",
  },
  tableHeader: {
    padding: "16px",
  },
  imageItem: {
    cursor: "pointer",
    backgroundSize: "100% 100%",
    borderRadius: "0.25rem",
  },
});
